<template>
  <v-container fluid class="app">
    <v-erro
      :icone="icone"
      :nomeDoErro="nomeDoErro"
      :mensagemDeErro="mensagemDeErro" />
  </v-container>
</template>

<script>
import VErro from "../components/VErro.vue"
export default {
  name: "PaginaNaoEncontrada",
  components: {
    VErro,
  },
  data() {
    return {
      icone: "mdi-alert-octagon",
      nomeDoErro: "Página não econtrada",
      mensagemDeErro:
        "A página pesquisada não existe ou não está mais disponível.",
    }
  },
}
</script>
